import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Common Components
import { Header, Footer } from './components';

// Page Components
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ActivitiesPage from './pages/ActivitiesPage';
import RoomsPage from './pages/RoomsPage';
import GalleryPage from './pages/Gallery';
import BookingPage from './pages/BookingPage';
import ContactPage from './pages/ContactPage';

// Admin Components
import AdminLogin from './components/Admin/AdminLogin';
import AdminLayout from './components/Admin/AdminLayout';
import AdminDashboard from './components/Admin/AdminDashboard';
import BookingsManagement from './components/Admin/BookingsManagement';
import RoomsManagement from './components/Admin/RoomsManagement';
import MessagesManagement from './components/Admin/MessagesManagement';
import HeroManagement from './components/Admin/HeroManagement';
import FacilitiesManagement from './components/Admin/FacilitiesManagement';
import GalleryManagement from './components/Admin/GalleryManagement';
import VideoTestimonialsManagement from './components/Admin/VideoTestimonialsManagement';
import ProtectedRoute from './components/Admin/ProtectedRoute';
import ScrollToTop from './components/common/ScrollToTop';

function App() {
  return (
    <Router>
       <ScrollToTop />
      {/* Render Header and Footer only for non-admin routes */}
      {window.location.pathname.indexOf('/admin') === -1 && <Header />}
      <main>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/activities" element={<ActivitiesPage />} />
          <Route path="/rooms" element={<RoomsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/bookings" element={
            <ProtectedRoute>
              <AdminLayout>
                <BookingsManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/rooms" element={
            <ProtectedRoute>
              <AdminLayout>
                <RoomsManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/messages" element={
            <ProtectedRoute>
              <AdminLayout>
                <MessagesManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/hero" element={
            <ProtectedRoute>
              <AdminLayout>
                <HeroManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/facilities" element={
            <ProtectedRoute>
              <AdminLayout>
                <FacilitiesManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/gallery" element={
            <ProtectedRoute>
              <AdminLayout>
                <GalleryManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/video-testimonials" element={
            <ProtectedRoute>
              <AdminLayout>
                <VideoTestimonialsManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
        </Routes>
      </main>
      {window.location.pathname.indexOf('/admin') === -1 && <Footer />}
    </Router>
  );
}

export default App;
